import React, { useEffect } from "react";
import { RecoilRoot } from "recoil";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Modal from "react-modal";
import AssetPage from "./pages/assets/index";
import SwapPage from "./pages/swap/index";
import PoolsPage from "./pages/pools/index";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import NavigationSidebar from "./components/common/layout/NavigationSidebar";
import { useConnectWallet } from "./hooks/useTxnClient";
import Poolinfo from "./components/pools/Poolinfo";
import PoolsInfo from "./pages/poolsinfo";
import { ToastContainer } from "react-toastify";
import NetSwitch from "./components/common/layout/NetSwitch";

Modal.setAppElement("#root");

function App() {
  return (
    <RecoilRoot>
      <Router>
        <div className="App">
          <NavigationSidebar />
          <div className="component-container">
            <NetSwitch />
            <Routes>
              <Route path="/" element={<SwapPage />} />
              <Route path="/asset" element={<AssetPage />} />
              <Route path="/pools" element={<PoolsPage />} />
              <Route path="/pools/:id" element={<PoolsInfo />} />
            </Routes>
          </div>
          <ToastContainer className="toastcustom_style" />
        </div>
      </Router>
    </RecoilRoot>
  );
}

export default App;
